<div class="loading" *ngIf="dataLoading">
    <mat-spinner></mat-spinner>
</div>


<div *ngIf="!dataLoading">
  <h1 *ngIf="currentCategory" style="margin-bottom:0;margin-block-end:0;">{{ currentCategory.title }}</h1>

  <div *ngFor="let category of catoriesChildren | orderByGroup:'title':'asc'">

    <div *ngIf="category.title != currentCategory.title">
        <app-category [thisCategory]="category" *ngIf="category.fileCount > 0"></app-category>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/categories/categories.component.html